import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_UR,
    useChartsData
} from '../../../../Common/hooks/useChartsData';

export const DatabaseChartsDataContext = createContext();

const DatabaseChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_UR.DATABASE_MAPPING,
            url: 'governanceroom/dashboard/unifiedregistry/mapping/database'
        },
        {
            location: filters.unidade.value,
            city: filters.cidade?.value,
        }
    );

    const chartData = data
        ? {
              indicators: {
                  registerUpdate: data?.indicators?.registerUpdate ?? 0,
                  bolsaFamiliaReceiving: data?.indicators?.bolsaFamiliaReceiving ?? 0,
                  absenceOfHomeVisit: data?.indicators?.absenceOfHomeVisit ?? 0
              },
              familiesUpdate: data?.familiesUpdate ?? [],
              familiesRegister: data?.familiesRegister ?? [],
              collectionMethod: data?.collectionMethod ?? [],
              bolsaFamilia: data?.bolsaFamilia ?? []
          }
        : {
              indicators: {
                  registerUpdate: 0,
                  bolsaFamiliaReceiving: 0,
                  absenceOfHomeVisit: 0
              },
              familiesUpdate: [],
              familiesRegister: [],
              collectionMethod: [],
              bolsaFamilia: []
          };

 

    return (
        <DatabaseChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </DatabaseChartsDataContext.Provider>
    );
};

export default DatabaseChartsDataProvider;
